import { type FC } from "react";
import { useTranslation } from "react-i18next";
import { useFilter } from "@/partner/shared/components/Filter";
import { SimpleTableCard } from "@/partner/shared/components/SimpleTableCard";
import { formatNumber } from "@/shared/utils/formatNumber";
import { useAnalyticsUsersByLanguageQuery } from "@/partner/entities/analytics";
import { DownloadReportButton } from "@/partner/features/reports";
import {
  AnalyticsWidgetType,
  ReportTypeType,
} from "@/types/graphql/partner.generated";

export const AnalyticsUsersByLanguageTable: FC = () => {
  const { t } = useTranslation();
  const { filter } = useFilter();

  const { data, loading, error } = useAnalyticsUsersByLanguageQuery({
    variables: { filter: filter as never },
  });

  const rows = (data?.analyticsUsers.usersByLanguage ?? []).map((row) => [
    row.language,
    formatNumber(row.users),
  ]);

  return (
    <SimpleTableCard
      title={t("analytics.users.tableByLanguage")}
      columns={[
        { name: t("analytics.users.columnLanguage") },
        { name: t("analytics.users.columnUsers") },
      ]}
      rows={rows}
      loading={loading}
      error={error}
      downloadButton={
        <DownloadReportButton
          variant="card"
          type={ReportTypeType.AnalyticsWidgetType}
          widget={AnalyticsWidgetType.UsersByLanguageType}
          filter={filter}
        />
      }
    />
  );
};
